<article
	class="flex flex-col flex-1 items-center bg-white max-w-5xl w-[60vw] p-16 rounded-2xl"
>
	<img
		src="/assets/images/closer-logos/closer-logo-full.webp"
		alt="Closer Logo"
		class="mb-6 mt-8 md:my-0 max-w-44 self-start"
	/>

	<section class="flex flex-col gap-8 items-center mt-4 max-w-lg">
		<img
			[src]="imageUrl"
			[@pop]="playAnimation"
			alt="Email Sent"
			class="max-w-80 max-h-80 flex"
		/>

		<div class="flex flex-col items-center gap-4 text-center">
			<h1 class="text-3xl">{{ headingText }}</h1>
			<ng-content select="[paragraph-content]"></ng-content>
		</div>

		<ng-content select="[cta-content]"></ng-content>
	</section>
</article>
